module.exports = __webpack_public_path__ + "img/brand3.de6e8824.png";